import { createStore } from 'redux';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers from '../reducers';

const pricingTransform = createTransform(
  (state) => ({ ...state, isOpen: false }),
  (state) => ({ ...state, isOpen: false }),
  { whitelist: ['pricing'] }
);

const persistConfig = {
  key: 'root',
  storage,
  transforms: [pricingTransform],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(persistedReducer);
const persistor = persistStore(store);

export { store, persistor };
